export default __webpack_public_path__ + "static/media/Flag_of_Slovenia.386a86ef.svg";